@switch (mode()) {
	@case ('light') {
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			aria-hidden="true"
		>
			<path
				d="M5.63325 4.45L4.13325 2.95833L2.95825 4.13333L4.44992 5.625L5.63325 4.45ZM0.833252 9.16667H3.33325V10.8333H0.833252V9.16667ZM9.16658 0.875H10.8333V3.33333H9.16658V0.875ZM15.8666 2.95417L17.0399 4.12667L15.5483 5.61833L14.3758 4.445L15.8666 2.95417ZM14.3666 15.55L15.8583 17.05L17.0333 15.875L15.5333 14.3833L14.3666 15.55ZM16.6666 9.16667H19.1666V10.8333H16.6666V9.16667ZM9.99992 5C7.24158 5 4.99992 7.24167 4.99992 10C4.99992 12.7583 7.24158 15 9.99992 15C12.7583 15 14.9999 12.7583 14.9999 10C14.9999 7.24167 12.7583 5 9.99992 5ZM9.99992 13.3333C8.15825 13.3333 6.66658 11.8417 6.66658 10C6.66658 8.15833 8.15825 6.66667 9.99992 6.66667C11.8416 6.66667 13.3333 8.15833 13.3333 10C13.3333 11.8417 11.8416 13.3333 9.99992 13.3333ZM9.16658 16.6667H10.8333V19.125H9.16658V16.6667ZM2.95825 15.8667L4.13325 17.0417L5.62492 15.5417L4.44992 14.3667L2.95825 15.8667Z"
				fill="currentColor"
			/>
		</svg>
	}
	@case ('auto') {
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			aria-hidden="true"
		>
			<path
				d="M15.8333 3.33333H4.16667C3.24583 3.33333 2.5 4.07917 2.5 5V12.5C2.5 13.4208 3.24583 14.1667 4.16667 14.1667H8.33333V15.8333H6.66667V17.5H13.3333V15.8333H11.6667V14.1667H15.8333C16.7542 14.1667 17.5 13.4208 17.5 12.5V5C17.5 4.07917 16.7542 3.33333 15.8333 3.33333ZM15.8333 12.5H4.16667V5H15.8333V12.5Z"
				fill="currentColor"
			/>
		</svg>
	}
	@case ('dark') {
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			aria-hidden="true"
		>
			<path
				d="M12.0833 3.33464C12.3667 3.33464 12.65 3.3513 12.925 3.39297C11.3333 5.19297 10.4167 7.54297 10.4167 10.0013C10.4167 12.4596 11.3333 14.8096 12.925 16.6096C12.65 16.6513 12.3667 16.668 12.0833 16.668C8.40833 16.668 5.41667 13.6763 5.41667 10.0013C5.41667 6.3263 8.40833 3.33464 12.0833 3.33464ZM12.0833 1.66797C7.48333 1.66797 3.75 5.4013 3.75 10.0013C3.75 14.6013 7.48333 18.3346 12.0833 18.3346C13.6 18.3346 15.025 17.918 16.25 17.2096C13.7583 15.768 12.0833 13.0846 12.0833 10.0013C12.0833 6.91797 13.7583 4.23464 16.25 2.79297C15.025 2.08464 13.6 1.66797 12.0833 1.66797Z"
				fill="currentColor"
			/>
		</svg>
	}
	@default {
		<!-- Invalid mode; input transform should throw before render -->
	}
}
